import React from 'react'

import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'

import './home.css'

const Home = () => (
    <>
      <Helmet>
        <link rel="canonical" href="https://sisu.ryansshane.com" />
        <title>sisu</title>
        <meta name="description" content="sisu" />
      </Helmet>
      <div className='content'>
        <h1>sisu</h1>
      </div>
    </>
  );

export default Home;